// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "6dcdac4907034b0fbf608ea3ea76c45f3874dede/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};